@if (isRolloutMetricLayerVisible() || isRoadCoverageLayerVisible() || isSpeedProfileLayerVisible()) {
  <div class="position-absolute bottom-20 end-5 z-1">
    <app-legend>
      @if (isRolloutMetricLayerVisible()) {
        <app-legend-category name="Rollouts" [metric]="rolloutMetric()"></app-legend-category>
      }
      @if (isRoadCoverageLayerVisible()) {
        <app-legend-category
          name="Road Coverage"
          [metric]="roadCoverageMetric"
        ></app-legend-category>
      }
      @if (isSpeedProfileLayerVisible()) {
        <app-legend-category
          name="Speed Profile"
          [metric]="speedProfileMetric"
        ></app-legend-category>
      }
    </app-legend>
  </div>
}
